import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { trackBookingCtaClick } from '../../utils/metaPixel';
import { scrollToBooking } from '../../utils/scrollToBooking';
export function StickyMobileCta() {
  const {
    t
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const target = document.getElementById('calificar') || document.getElementById('contacto');
      const scrollY = window.scrollY;
      const showAfter = 600;
      // Hide only once the wizard is actually on screen — otherwise the
      // patient loses their guide right before the thing they need to do.
      const hideBefore = target ? target.offsetTop - 240 : Infinity;
      setIsVisible(scrollY > showAfter && scrollY < hideBefore);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    trackBookingCtaClick('sticky_mobile');
    scrollToBooking();
  };
  return <AnimatePresence data-id="element-460" data-mp="12g7zxhp1je46">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: [0.33, 1, 0.68, 1]
    }} className="lg:hidden fixed bottom-6 left-6 right-6 z-40" data-id="element-461" data-mp="12f5dblyr3xu2">
          <button onClick={scrollToContact} className="w-full bg-brand-dark/95 backdrop-blur-md text-brand-cream rounded-full shadow-2xl px-6 py-4 flex items-center justify-between active:scale-[0.98] transition-transform border border-brand-gold/30" data-id="element-462" data-mp="ipuy092x3ewh">
            <span className="text-xs font-semibold tracking-[0.15em] uppercase text-brand-cream" data-id="element-463" data-mp="es6u4gj8ybsg">
              {t('stickyCta.text')}
            </span>
            <span className="flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-brand-gold" data-id="element-464" data-mp="2bnic8mgkpx2l">
              {t('stickyCta.button')}
              <span data-id="element-465" data-mp="26n44z6msqr5m">→</span>
            </span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}